import { useEffect } from 'react';

/**
 * Locks body scroll while `locked` is truthy. Restores previous overflow on
 * cleanup. Handles both `<html>` and `<body>` because mobile Safari needs
 * both to fully block background scroll.
 *
 * Use it inside every fullscreen / bottom-sheet modal. Centralizing this
 * avoids inconsistent implementations (some files were locking only body,
 * some only html, some both — restoration semantics differed across them).
 */
export function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return;
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.overflow;
    const prevBody = body.style.overflow;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prevHtml;
      body.style.overflow = prevBody;
    };
  }, [locked]);
}

export default useBodyScrollLock;
